// core/action/expenseActions.js
import { expenseAPI } from './api';
import { toast } from 'react-toastify';

export const expenseActions = {
    // Get expenses list with pagination
    getExpenses: async (params = {}) => {
        try {
            const response = await expenseAPI.list(params);
            
            console.log('Raw API Response:', response); // Debug log
            
            // Check if response exists and has data
            if (response && response.data) {
                // Your API returns: { success: true, data: {...} }
                if (response.data.success === true && response.data.data) {
                    const apiData = response.data.data;
                    return {
                        success: true,
                        data: apiData.expenses || [],
                        total: apiData.total || 0,
                        page: apiData.page || 1,
                        limit: apiData.limit || 10,
                        totalPages: apiData.total_pages || 1,
                        summary: apiData.summary || {
                            total_expenses: 0,
                            total_amount: 0,
                            average_amount: 0,
                            total_categories: 0,
                            total_payment_methods: 0
                        },
                        monthlySummary: apiData.monthly_summary || [],
                        categorySummary: apiData.category_summary || []
                    };
                }
                // If response.data is already the data (no success wrapper)
                else if (response.data.expenses !== undefined) {
                    return {
                        success: true,
                        data: response.data.expenses || [],
                        total: response.data.total || 0,
                        page: response.data.page || 1,
                        limit: response.data.limit || 10,
                        totalPages: response.data.total_pages || 1,
                        summary: response.data.summary || {
                            total_expenses: 0,
                            total_amount: 0,
                            average_amount: 0,
                            total_categories: 0,
                            total_payment_methods: 0
                        },
                        monthlySummary: response.data.monthly_summary || [],
                        categorySummary: response.data.category_summary || []
                    };
                }
            }
            
            // If response itself is the data (no .data wrapper)
            if (response && response.expenses !== undefined) {
                return {
                    success: true,
                    data: response.expenses || [],
                    total: response.total || 0,
                    page: response.page || 1,
                    limit: response.limit || 10,
                    totalPages: response.total_pages || 1,
                    summary: response.summary || {
                        total_expenses: 0,
                        total_amount: 0,
                        average_amount: 0,
                        total_categories: 0,
                        total_payment_methods: 0
                    },
                    monthlySummary: response.monthly_summary || [],
                    categorySummary: response.category_summary || []
                };
            }
            
            return {
                success: false,
                message: 'Invalid API response format',
                data: [],
                total: 0,
                page: 1,
                limit: 10,
                totalPages: 1,
                summary: {
                    total_expenses: 0,
                    total_amount: 0,
                    average_amount: 0,
                    total_categories: 0,
                    total_payment_methods: 0
                },
                monthlySummary: [],
                categorySummary: []
            };
        } catch (error) {
            console.error('Error fetching expenses:', error);
            return {
                success: false,
                message: error.message || 'Failed to fetch expenses',
                data: [],
                total: 0,
                page: 1,
                limit: 10,
                totalPages: 1,
                summary: {
                    total_expenses: 0,
                    total_amount: 0,
                    average_amount: 0,
                    total_categories: 0,
                    total_payment_methods: 0
                },
                monthlySummary: [],
                categorySummary: []
            };
        }
    },

    // Get single expense
    getExpense: async (id) => {
        try {
            const response = await expenseAPI.get(id);
            
            if (response && response.data) {
                if (response.data.success && response.data.data) {
                    return {
                        success: true,
                        data: response.data.data
                    };
                } else {
                    return {
                        success: true,
                        data: response.data
                    };
                }
            }
            return {
                success: false,
                message: 'Invalid API response format',
                data: null
            };
        } catch (error) {
            console.error('Error fetching expense:', error);
            return {
                success: false,
                message: error.message || 'Failed to fetch expense',
                data: null
            };
        }
    },

 // In expenseActions.js - Fix the createExpense method
// In expenseActions.js - Fix the createExpense method
createExpense: async (expenseData) => {
    try {
        // Validate required fields
        if (!expenseData) {
            return { success: false, message: 'No data provided' };
        }
        
        // For FormData, we need to extract values for validation
        let expenseDate, amount, paymentMethod;
        
        if (expenseData instanceof FormData) {
            expenseDate = expenseData.get('expense_date');
            amount = expenseData.get('amount');
            paymentMethod = expenseData.get('payment_method');
        } else {
            expenseDate = expenseData.expense_date;
            amount = expenseData.amount;
            paymentMethod = expenseData.payment_method;
        }
        
        if (!expenseDate) {
            return { success: false, message: 'Expense date is required' };
        }
        if (!amount || parseFloat(amount) <= 0) {
            return { success: false, message: 'Valid amount is required' };
        }
        if (!paymentMethod) {
            return { success: false, message: 'Payment method is required' };
        }
        
        console.log('Sending expense data to API:', expenseData);
        
        const response = await expenseAPI.create(expenseData);
        
        console.log('Create expense response:', response);
        
        // Check if response exists
        if (response && response.data) {
            // The API returns { success: true, message: '...', data: {...} }
            // IMPORTANT: response.data is the actual API response, not wrapped
            if (response.success === true) {
                toast.success(response.message || 'Expense created successfully');
                return {
                    success: true,
                    data: response.data,
                    message: response.message || 'Expense created successfully'
                };
            } else {
                // API returned success: false
                toast.error(response.message || 'Failed to create expense');
                return {
                    success: false,
                    message: response.message || 'Failed to create expense'
                };
            }
        }
        
        // If we get here, response format is unexpected
        console.error('Unexpected API response format:', response);
        toast.error('Failed to create expense');
        return {
            success: false,
            message: 'Failed to create expense'
        };
    } catch (error) {
        console.error('Error creating expense:', error);
        
        // Check if error response has data
        if (error.response && error.response.data) {
            const errorMsg = error.response.message || error.message;
            toast.error(errorMsg);
            return {
                success: false,
                message: errorMsg
            };
        }
        
        toast.error(error.message || 'Failed to create expense');
        return {
            success: false,
            message: error.message || 'Failed to create expense'
        };
    }
},
   // Update expense
updateExpense: async (id, expenseData) => {
    try {
        if (!id) {
            return { success: false, message: 'Expense ID is required' };
        }
        
        // If expenseData is FormData, we need to handle it differently
        let response;
        if (expenseData instanceof FormData) {
            // Ensure id is in the FormData
            if (!expenseData.has('id')) {
                expenseData.append('id', id);
            }
            response = await expenseAPI.update(id, expenseData);
        } else {
            // Regular object
            expenseData.id = id;
            response = await expenseAPI.update(id, expenseData);
        }
        
        console.log('Update expense response:', response);
        
        if (response && response.data) {
            // Check the response structure
            // Your API returns { success: true, message: '...', data: {...} }
            if (response.success === true) {
                toast.success(response.message || 'Expense updated successfully');
                return {
                    success: true,
                    data: response.data,
                    message: response.message || 'Expense updated successfully'
                };
            } else {
                toast.error(response.message || 'Failed to update expense');
                return {
                    success: false,
                    message: response.message || 'Failed to update expense'
                };
            }
        }
        
        toast.error('Failed to update expense');
        return {
            success: false,
            message: 'Failed to update expense'
        };
    } catch (error) {
        console.error('Error updating expense:', error);
        
        // Check if error response has data
        if (error.response && error.response.data) {
            const errorMsg = error.response.message || error.message;
            toast.error(errorMsg);
            return {
                success: false,
                message: errorMsg
            };
        }
        
        toast.error(error.message || 'Failed to update expense');
        return {
            success: false,
            message: error.message || 'Failed to update expense'
        };
    }
},
    // Delete expense
    deleteExpense: async (id) => {
        try {
            if (!id) {
                return { success: false, message: 'Expense ID is required' };
            }
            
            const response = await expenseAPI.delete({ id });
            debugger;
            
                if (response.success) {
                    toast.success('Expense deleted successfully');
                    return {
                        success: true,
                        message: response.message || 'Expense deleted successfully'
                    };
                } else {
                    toast.error(response.message || 'Failed to delete expense');
                    return {
                        success: false,
                        message: response.message || 'Failed to delete expense'
                    };
                }
           
            
         
        } catch (error) {
            console.error('Error deleting expense:', error);
            toast.error('Failed to delete expense');
            return {
                success: false,
                message: error.message || 'Failed to delete expense'
            };
        }
    },

    // Get expense categories
    getCategories: async () => {
        try {
            const response = await expenseAPI.getCategories();
            debugger;
            console.log('Categories API Response:', response); // Debug log
            
           
                // If response.data has success and data structure
                if (response.success && response.data.categories
) {
                    return {
                        success: true,
                        data: response.data.categories

                    };
                }else {
    
            return {
                success: false,
                message: 'Invalid API response format',
                data: []
            };
                }
               
          
        
        } catch (error) {
            console.error('Error fetching categories:', error);
            return {
                success: false,
                message: error.message || 'Failed to fetch categories',
                data: []
            };
        }
    },

    // Format currency helper
    formatCurrency: (amount, currency = 'INR') => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    },

    // Format date helper
    formatDate: (dateString) => {
        if (!dateString) return 'N/A';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-IN', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric'
            });
        } catch {
            return dateString;
        }
    },

    // Get payment method badge class
    getPaymentMethodBadge: (method) => {
        const classes = {
            'cash': 'bg-success',
            'bank_transfer': 'bg-primary',
            'cheque': 'bg-info',
            'credit_card': 'bg-warning',
            'upi': 'bg-secondary'
        };
        return classes[method] || 'bg-secondary';
    },

    // Get payment method icon
    getPaymentMethodIcon: (method) => {
        const icons = {
            'cash': '💰',
            'bank_transfer': '🏦',
            'cheque': '📝',
            'credit_card': '💳',
            'upi': '📱'
        };
        return icons[method] || '💵';
    },

    // Get status badge class
    getStatusBadge: (status) => {
        const classes = {
            'paid': 'bg-success',
            'unpaid': 'bg-warning',
            'pending': 'bg-info'
        };
        return classes[status] || 'bg-secondary';
    }
};

export default expenseActions;